import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from 'src/app/material-module';
import { GoogleLoginProvider, FacebookLoginProvider } from "angularx-social-login";

import { SocialLoginModule, AuthServiceConfig } from "angularx-social-login";
import { TokenInterceptor } from './http/interceptors/token.interceptor';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BreadcrumbModule } from 'angular-crumbs';
import { NumberToArrayPipe } from '../shared/pipe/number-to-array.pipe';
import { LessonStringPipe } from '../shared/pipe/lesson-string.pipe';
import { PipesModule } from '../shared/pipe/pipe.module';

import { CookieService } from 'ngx-cookie-service';

let config = new AuthServiceConfig([
  /*{
    id: GoogleLoginProvider.PROVIDER_ID,
     provider: new GoogleLoginProvider("Google-OAuth-Client-Id")
  },*/
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider("434915763992002")
  }
]);
 
export function provideConfig() {
  return config;
}

@NgModule({
  declarations: [
  
  ],
  imports: [
      CommonModule,
      RouterModule,
      BrowserAnimationsModule,
      MaterialModule,
      SocialLoginModule,
      BreadcrumbModule,
      PipesModule,
      HttpClientModule,
  ],
  providers: [
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    CookieService
  ],
  exports: [
    NumberToArrayPipe,
    LessonStringPipe,
  ]
})
export class CoreModule { }
